/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentFrequency = {
    Monthly: 'Monthly',
    Quarterly: 'Quarterly',
    HalfYearly: 'HalfYearly',
    Yearly: 'Yearly',
    Other: 'Other',
    OneTime: 'OneTime'
} as const;
export type PaymentFrequency = typeof PaymentFrequency[keyof typeof PaymentFrequency];


export function instanceOfPaymentFrequency(value: any): boolean {
    for (const key in PaymentFrequency) {
        if (Object.prototype.hasOwnProperty.call(PaymentFrequency, key)) {
            if (PaymentFrequency[key as keyof typeof PaymentFrequency] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentFrequencyFromJSON(json: any): PaymentFrequency {
    return PaymentFrequencyFromJSONTyped(json, false);
}

export function PaymentFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentFrequency {
    return json as PaymentFrequency;
}

export function PaymentFrequencyToJSON(value?: PaymentFrequency | null): any {
    return value as any;
}

export function PaymentFrequencyToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentFrequency {
    return value as PaymentFrequency;
}

